import React from 'react';
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import { NavLink } from "react-router-dom";
import { themeButtons } from "../../css/themeButtons";
import FunctionSidebarContainer from "../common/FunctionSidebar/FunctionSidebarContainer";
import Preloader from "../common/Preloader/Preloader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Skeleton from "@material-ui/lab/Skeleton";


const RenderRequiredStep = ({ stepName, stepStatus, objectId }) => {

  const requiredStep = {
    "verifiedUser": {
      title: 'Аккаунт не подтвержден',
      text: 'Подтвердите аккаунт для дальнейшего подтверждения договора',
      btnText: 'Подтвердить',
      link: `/lk/verifiedUser`,
    },
    "emailToProfile": {
      title: 'Не заполнено поле Email в профиле',
      text: 'Добавьте Email что-бы не пропустить не одного уведомления',
      link: `/lk/verifiedUser`,
    },
    "phoneToProfile": {
      title: 'Аккаунт не подтвержден',
      text: 'Добавьте телефон что-бы не пропустить не одного уведомления',
      link: `/lk/verifiedUser`,
    },
    "contacts": {
      title: 'Контакты',
      text: 'Добавьте контакты',
      link: `/lk/${objectId}/contacts`,
    },
    "about": {
      title: 'Описание',
      text: 'Добавьте описание',
      link: `/lk/${objectId}/about`,
    },
    "photo": {
      title: 'Фотографии',
      text: 'Добавьте фотографии',
      link: `/lk/${objectId}/photo`,
    },
    "rooms": {
      title: 'Номера',
      text: 'Добавьте номера',
      link: `/lk/${objectId}/rooms`,
    },
    "bookings": {
      title: 'Бронирования',
      text: 'Список бронирований этого объекта',
      link: `/lk/${objectId}/bookings`,
      btnText: 'Смотреть/управлять',
    }
  }

  const buttons = themeButtons();

  if (!stepName) {
    return <Skeleton width={"100%"}/>
  }

  return (
    <div className="col-xxl-6">
      <Card className={`card requiried-step ${!stepStatus && 'requiried-step__warning'}`}>
        <CardContent className="card-body">
          <div className="requiried-step__title-wrp">
            <h5 className="card-title me-3">{requiredStep[stepName].title}</h5>

            {stepStatus
              ? <Button component={NavLink} to={requiredStep[stepName].link}
                        className={`btn ${buttons.btnLight}`}>
                <FontAwesomeIcon icon={["far", "edit"]} className="me-1"/> Изменить</Button>
              : <Button component={NavLink} to={requiredStep[stepName].link}
                        className={`btn ${buttons.btnGreen}`}>
                {requiredStep[stepName].btnText
                  ? requiredStep[stepName].btnText
                  : 'Добавить'}
              </Button>}


          </div>
          <p className="card-text">
            {requiredStep[stepName].text}
          </p>
        </CardContent>
      </Card>

    </div>
  )
}

const ObjectMain = (props) => {
  const { requiredSteps, verifiedUser, objectId } = props


  if (!requiredSteps) {
    return <Preloader loading={true} text={"Загрузка..."}/>
  }
  return (
    <div className="main edit-object">
      <div className="container-fluid">
        <div className="requiried-steps">
          <div className="row g-2">
            {!verifiedUser &&
              <RenderRequiredStep stepName={"verifiedUser"} stepStatus={verifiedUser} objectId={objectId}/>}

            {Object.keys(requiredSteps).map(key => <RenderRequiredStep key={key} stepName={key}
                                                                       stepStatus={requiredSteps[key]}
                                                                       objectId={objectId}/>)}

            <RenderRequiredStep stepName={"bookings"}
                                objectId={objectId}/>
          </div>
        </div>
      </div>
      <FunctionSidebarContainer/>
    </div>
  )
}


export default ObjectMain;
